import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';

export class CheckBoxOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**
 *   Represent classes to CheckBox that allow us to select the TextBox by jquery or javascript 
 */
 
  ExtraClasses:string

 /**  Represent value of the label*/
  LabelValue:string
   /**  Represent Key of the label*/
 LabelKey:string
  /**  Represent value of the labelDescription show under CheckBox*/
  LabelDescription:string
  /**To set  value  to CheckBox */
  Value:boolean=null
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  CheckBox required */
  IsRequired: boolean
 
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  
  /** Set List of Custom Attribute to CheckBox  */
  AttributeList:Attribute[]
   /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
ForceDirection: ForceDirection=ForceDirection.English

}